import React from "react"

import Icon from "icons"
import GeneralCard from "../base"
import { BylineAuthor } from "../base/styles"
import { ClassShortIcon, ClassCategory, ClassesLogo, BottomRight } from "./styles"

const ClassCard = ({
  url,
  author,
  instructorByline,
  headline,
  category,
  inline,
  subheadline,
  hideOnPageLoad,
  localLink,
  ...props
}) => (
  <GeneralCard
    {...props}
    hideOnPageLoad={hideOnPageLoad}
    subheadline={subheadline}
    headline={headline}
    link={url}
    localLink={localLink}
    topLeftElement={inline ? <ClassesLogo /> : <ClassCategory>{category} Class</ClassCategory>}
    topRightElement={<ClassShortIcon id="shop-icon" height={15} width={15} />}
    bylineElement={
      (author && (
        <BylineAuthor>
          With {/* <a href={`/wc/${slugify(author)}`} title={author}> */}
          {author}
          {/* </a> */}
        </BylineAuthor>
      )) ||
      (instructorByline && <BylineAuthor>{instructorByline}</BylineAuthor>)
    }
    bottomRightElement={
      !inline && (
        <BottomRight>
          <Icon id="media-play-icon" width={36} height={36} />
        </BottomRight>
      )
    }
  />
)

export default ClassCard
